import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AuthInterceptor, AuthModule, LogLevel } from 'angular-auth-oidc-client';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { InitService } from './init.service';
export function initApp(initService: InitService) {
  return async () => {
    const authenticated = await initService.checkToken();

    if (authenticated) {
      initService.setUserInfoN();
    }
  };
}
@NgModule({
  imports: [
    AuthModule.forRoot({
      config: {
        authority: environment.identityUrl,
        redirectUrl: `${window.location.origin}`,
        postLogoutRedirectUri: environment.identityUrl,
        clientId: 'coo-tools',
        scope: 'coo-tools openid profile offline_access',
        responseType: 'code',
        checkRedirectUrlWhenCheckingIfIsCallback: true,
        silentRenew: true,
        useRefreshToken: true,
        historyCleanupOff: false,
        secureRoutes: [environment.baseUrl, environment.baseUrl, '/api'],
        logLevel: LogLevel.None,
      },
    }),
  ],
  providers: [
    InitService,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [InitService],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
})
export class InitModule {}
